<script setup lang="ts">
import { useDisciplineStore } from '../model/store'
import { useLessonRecurringStore } from '../model/lessons/recurring/store'
import { useLessonRecurringPage } from '../model/lessons/lesson-recurring-page.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import LessonCreateRecurring from './lessons/LessonCreateRecurring.vue'

defineOptions({
  name: 'LessonCreateRecurringPage',
})

const disciplineStore = useDisciplineStore()
const lessonRecurringStore = useLessonRecurringStore()

const { refIsLoading } = useLessonRecurringPage()
</script>

<template>
  <DisciplinePageLoader :loading="refIsLoading" />
  <LessonCreateRecurring
    v-if="disciplineStore.getDiscipline && lessonRecurringStore.getSlots"
  />
</template>
